import { z, TypeOf } from 'zod';
import useLocalStorage, { type LocalStorageOptions } from 'use-local-storage-state';

export const authTokenSchema = z.object({
  id: z.string().optional(),
  expires_at: z.string().datetime(),
  token: z.string(),
  user_id: z.string(),
});

export type AuthToken = TypeOf<typeof authTokenSchema>;

const opts: LocalStorageOptions<AuthToken | null> = {
  serializer: {
    parse: (value: string) => authTokenSchema.parse(JSON.parse(value)),
    stringify: (value) => (value ? JSON.stringify(value) : ''),
  },
};

export function useAuthToken() {
  return useLocalStorage<AuthToken | null>('mercury_nxt_token', opts);
}
